import React, { useState, useEffect } from "react";
import { Form, Col, Row, Button, Modal } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { Typeahead } from "react-bootstrap-typeahead";

import "react-datepicker/dist/react-datepicker.css";
import "../styles/InfantFeeding.css";
import { toast } from "react-toastify";
import axiosInstance from "../axiosInstance";

export default function InfantFeeding() {
  const [reference_number, setReferenceNumber] = useState([]);
  const [startDate, setStartDate] = useState(new Date());
  const [wake_up_time, setWakeUpTime] = useState(new Date());
  const [formula, setFormula] = useState("Royal Canin Kitty");
  const [volume, setVolume] = useState(0);
  const [defacation, setDefacation] = useState("No");
  const [defacation_count, setDefacationCount] = useState(1);
  const [weight, setWeight] = useState(0);
  const [comments, setComments] = useState("");
  const [multiple_defacation, setMultipleDefacation] = useState(false);

  const [options, setOptions] = useState([]);

  const [showSave, setShowSave] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const handleCloseSave = () => setShowSave(false);
  const handleCloseSuccess = () => setShowSuccess(false);
  const handleSave = () => {
    submit();
    setShowSave(false);
  };
  function handleShowSave(e) {
    e.preventDefault();
    setShowSave(true);
  }

  async function getReferences() {
    const result = await axiosInstance.get("/api/all-reference-numbers");
    const numbers = result.data;
    const refs = [];
    numbers.forEach((element) => {
      refs.push(element.reference_number);
    });
    setOptions(refs);
  }

  useEffect(() => {
    getReferences();
  }, []);

  async function submit() {
    const ref = reference_number[0];
    var result = await axiosInstance.post("/api/add-infant-feeding", {
      date: startDate,
      reference_number: ref,
      wake_up_time,
      formula,
      defacation,
      defacation_count,
      volume,
      weight,
      comments,
    });
    if (result.data.code !== "ER_PARSE_ERROR") {
      toast.success(result.data, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
      });
      setReferenceNumber([]);
      setComments("");
      setDefacation("No");
      setDefacationCount(0);
      setWeight(0);
      setWakeUpTime(new Date());
      setStartDate(new Date());
      setFormula("Royal Canin Kitty");
      setVolume(0);
      setMultipleDefacation(false);
    } else {
      toast.error(result.data.sqlMessage, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
      });
    }
  }

  const getFormula = () => {
    if (formula === "Other") {
      setFormula("");
      return "";
    }
    if (formula === "Royal Canin Kitty" || formula === "Royal Canin Puppy") {
      return "";
    }
    return formula;
  };

  return (
    <div className="infant">
      <div className="formGroup">
        <h2 className="heading">Infant Feeding</h2>
        <Form.Group as={Col} controlId="formGroupDate">
          <DatePicker
            className="datepicker"
            selected={startDate}
            onChange={(date) => setStartDate(date)}
            showTimeSelect
            timeIntervals={1}
            dateFormat="dd/MM/yyyy HH:mm"
          />
        </Form.Group>
        <Form>
          <Row>
            <Col xs={3}>
              <Form.Group as={Col} controlId="formGroupReference">
                <Form.Label>Reference Number</Form.Label>
                <Typeahead
                  id="reference-number"
                  labelKey="name"
                  onChange={setReferenceNumber}
                  options={options}
                  placeholder="Choose a refrence number..."
                  selected={reference_number}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col xs={3}>
              <Form.Group as={Col} controlId="formGroupHealth">
                <Form.Label>Formula</Form.Label>
                <Form.Control
                  as="select"
                  defaultValue="Choose..."
                  onChange={(e) => setFormula(e.target.value)}
                >
                  <option value="Royal Canin Kitty">Royal Canin Kitty</option>
                  <option value="Royal Canin Puppy">Royal Canin Puppy</option>
                  <option value="Other">Other</option>
                </Form.Control>
                <br />
                <Form.Control
                  as="textarea"
                  rows={2}
                  placeholder="Other Formula Details"
                  value={getFormula()}
                  onChange={(e) => setFormula(e.target.value)}
                  disabled={
                    formula === "Royal Canin Kitty" ||
                    formula === "Royal Canin Puppy"
                  }
                />
              </Form.Group>
            </Col>
            <Col xs={3}>
              <Form.Group as={Col} controlId="formGroupVolume">
                <Form.Label>Volume</Form.Label>
                <Row>
                  <Col xs={10}>
                    <Form.Control
                      type="text"
                      placeholder="Volume"
                      value={volume}
                      onChange={(e) => {
                        const regex = new RegExp(
                          "^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$"
                        );
                        if (regex.test(e.target.value)) {
                          const s = e.target.value.replace(
                            /^(?:0+(?=[1-9])|0+(?=0$))/gm,
                            ""
                          );
                          setVolume(s);
                        } else if (e.target.value === "") {
                          setVolume(0);
                        }
                      }}
                    />
                  </Col>
                  <Col className="labelcol">
                    <Form.Label className="label">ml</Form.Label>
                  </Col>
                </Row>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col xs={3}>
              <Form.Group as={Col} controlId="formGroupDefacation">
                <Form.Label>Defacation</Form.Label>
                <Form.Check
                  type="radio"
                  id="defacation-radio-yes"
                  label="Yes"
                  name="defacationRadios"
                  value="Yes"
                  onChange={(e) => {
                    setDefacation(e.target.value);
                    setDefacationCount(1);
                  }}
                  checked={defacation === "Yes"}
                />
                <Form.Check
                  type="radio"
                  id="defacation-radio-no"
                  label="No"
                  name="defacationRadios"
                  value="No"
                  onChange={(e) => {
                    setDefacation(e.target.value);
                    setDefacationCount(0);
                  }}
                  checked={defacation === "No"}
                />
              </Form.Group>
            </Col>

            <Col>
              <Form.Group as={Col} controlId="formGroupMultipleDefacation">
                <Form.Label>Defacated More Than Once</Form.Label>
                <Form.Check
                  type="checkbox"
                  id="multiple-defacation"
                  label="Yes"
                  name="waterRadios"
                  value={!multiple_defacation}
                  onChange={(e) =>
                    setMultipleDefacation(e.target.value === "true")
                  }
                  checked={multiple_defacation}
                />
                <br />
                <Form.Label>How Many</Form.Label>
                <Form.Control
                  type="text"
                  style={{ width: `${200}px` }}
                  placeholder="How Many Times"
                  disabled={!multiple_defacation}
                  value={defacation_count}
                  onChange={(e) => {
                    if (parseInt(e.target.value, 10)) {
                      setDefacationCount(parseInt(e.target.value, 10));
                    } else {
                      setDefacationCount(0);
                    }
                  }}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col xs={3}>
              <Form.Group as={Col} controlId="formGroupTime">
                <Form.Label>Weight</Form.Label>
                <Row>
                  <Col xs={10}>
                    <Form.Control
                      type="text"
                      placeholder="Weight"
                      value={weight}
                      onChange={(e) => {
                        const regex = new RegExp(
                          "^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$"
                        );
                        if (regex.test(e.target.value)) {
                          const s = e.target.value.replace(
                            /^(?:0+(?=[1-9])|0+(?=0$))/gm,
                            ""
                          );
                          setWeight(s);
                        } else if (e.target.value === "") {
                          setWeight(0);
                        }
                      }}
                    />
                  </Col>
                  <Col className="labelcol">
                    <Form.Label className="label">kgs</Form.Label>
                  </Col>
                </Row>
              </Form.Group>
            </Col>
            <Col>
              <Form.Group as={Col} controlId="formGroupWake">
                <Form.Label>Wake Up Time</Form.Label>
                <br />
                <DatePicker
                  className="datepicker"
                  selected={wake_up_time}
                  onChange={(date) => setWakeUpTime(date)}
                  showTimeSelect
                  showTimeSelectOnly
                  timeIntervals={1}
                  dateFormat="HH:mm"
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group as={Col} controlId="formGroupDetails">
                <Form.Label>General Comments</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="General Comments"
                  value={comments}
                  onChange={(e) => setComments(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col>
              <Button
                className="submit-button"
                type="submit"
                onClick={(e) => {
                  handleShowSave(e);
                }}
              >
                Submit
              </Button>
            </Col>
          </Row>
        </Form>
      </div>
      <div>
        <Modal show={showSave} onHide={handleCloseSave}>
          <Modal.Header closeButton>
            <Modal.Title>Save</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <p>Are you sure you want to save this device.</p>
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseSave}>
              Close
            </Button>
            <Button variant="primary" onClick={handleSave}>
              Save changes
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
      <div>
        <Modal show={showSuccess} onHide={handleCloseSuccess}>
          <Modal.Header closeButton>
            <Modal.Title>Success</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Successfuly Submited.</p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseSuccess}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
}
